import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  BookAppointmentInfoContainer,
  BookAppointmentInfoTitleContainer
} from './BookAppointmentWidget.styled';
import { CalendarPlus } from 'assets/icons/Icons';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { themes } from 'kb-shared';
import { CustomList } from 'screens/Dashboard/CustomWidget/Components/CustomList';
import {
  ButtonsContainer,
  IconContainer,
  IllustratedBackgroundWidget,
  WidgetTitleContainer
} from 'screens/Dashboard/Widgets/Widgets.styled';
import { analytics } from 'utilities/analytics';
import { pageUrl } from 'utilities/pageUrl';

import {
  componentDescription,
  componentTitle,
  getAppointmentsOfferString
} from './BookAppointmentWidget.utils';

export const BookAppointmentWidget: React.FC = () => {
  const navigate = useNavigate();

  return (
    <IllustratedBackgroundWidget variant={9}>
      <IconContainer $iconWidth={42} $iconHeight={48}>
        <CalendarPlus type="solid" />
      </IconContainer>
      <WidgetTitleContainer>
        <Heading tag="div" styledAs="h2">
          {componentTitle}
        </Heading>
      </WidgetTitleContainer>
      <BookAppointmentInfoTitleContainer>
        <Text color={themes.colors.neutral.primaryNavy} fontStyle="medium" size="lg">
          {componentDescription}
        </Text>
      </BookAppointmentInfoTitleContainer>
      <BookAppointmentInfoContainer>
        <CustomList items={getAppointmentsOfferString()} type="bulleted" />
      </BookAppointmentInfoContainer>

      <ButtonsContainer>
        <Button
          category="primary-dark"
          size="lg"
          fullWidth
          label="Book an Appointment"
          onClick={() => {
            analytics.track(analytics.EVENTS.APPOINTMENT_BOOKING_STARTED);
            navigate(pageUrl.booking.bookingQuiz());
          }}
        />
      </ButtonsContainer>
    </IllustratedBackgroundWidget>
  );
};
